import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ToastService } from 'src/app/services/toast.service';
import { IConfirmDialogData } from 'src/app/models/confirm-data';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConfirmationDialogComponent {
  @Input() data: IConfirmDialogData;
  @Input() onAcceptButtonText: string = 'Accept';

  @Output() closeDialog = new EventEmitter<boolean>();
  @Output() acceptChanges = new EventEmitter<IConfirmDialogData>();

  constructor(private toastService: ToastService) {}

  public onAccept(): void {
    if (this.data.isRejectTraining && !this.data.rejectionReason) {
      this.toastService.error('Please provide a reason for rejection');
      return;
    }
    this.acceptChanges.emit(this.data);
    this.closeDialog.emit(true);
  }

  public onClose(): void {
    this.closeDialog.emit(true);
  }
}
